angular.module('unergie.main')
.controller('pdlsCtrl', ($scope, $location, $state, $stateParams, $filter, DownloadService, AccountService, AlertManager, DataAccess, DataAccessTags, ContractConstants,
    AdminComments, PrmUtilsService, NgTableParams, TableGeneratorService, ApiUser, DataAccessSearch, DataAccessInvoices, BoFeaturesService, AuthService,
    ModalService, ReferencesService, FilterMapping, OrganizationService, GovernmentPriceReductionPeriod, ErrorCatcher) => {
    // PRELOAD filter
    $filter('contractStatus')(0)
    const ACTIVABLE_STATUSES = [0, 9, 81, 82, 83]

    const feats = BoFeaturesService.getModuleFeatures('accountinfo')
    $scope.isAIFeatureOn = (feature) => feats[feature]
    $scope.pdlShowMassActions = BoFeaturesService.get('pdlShowMassActions')
    $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
    $scope.canSeeJira = BoFeaturesService.isFeatureOn('canSeeJira')
    $scope.jiraVDP = BoFeaturesService.isFeatureOn('jiraVDP')
    $scope.crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.modifOtPsB2G = BoFeaturesService.isFeatureOn('modifOtPsB2G')
    $scope.canTransferContractToAccount = BoFeaturesService.isFeatureOn('canTransferContractToAccount')
    $scope.canChangeCategoryAccount = BoFeaturesService.isFeatureOn('canChangeCategoryAccount')
    $scope.canSeeConsumptionDashboard = BoFeaturesService.isFeatureOn('canSeeConsumptionDashboard')
    $scope.canSeePDLBillingInfoConfiguration = BoFeaturesService.isFeatureOn('canSeePDLBillingInfoConfiguration')
    $scope.trainingMode = BoFeaturesService.isFeatureOn('trainingMode')
    $scope.canConfigurePDLBillingInfo = BoFeaturesService.isFeatureOn('canConfigurePDLBillingInfo')
    $scope.canSetGovernmentPriceReductions = BoFeaturesService.isFeatureOn('canSetGovernmentPriceReductions')
    $scope.canModifyConsents = BoFeaturesService.isFeatureOn('canModifyConsents')
    $scope.canModifyOtPsC2C4 = BoFeaturesService.isFeatureOn('canModifyOtPsC2C4')
    $scope.b2bgModificationAccess = BoFeaturesService.isFeatureOn('b2bgModificationAccess')
    $scope.canModifyContractDates = BoFeaturesService.isFeatureOn('canModifyContractDates')
    $scope.env = BoFeaturesService.getEnv()
    $scope.showButtons = ($scope.env !== 'prod') && ($scope.env.indexOf('-prod') < 0)

    ReferencesService.getRef('ref-tax-cspe', true).then((cspes) => {
        $scope.cspes = cspes

        const defaultPro = _.find($scope.cspes, { name: 'DEFAULT_PRO' }).toJSON()
        const defaultProHigh = _.find($scope.cspes, { name: 'DEFAULT_PRO_HIGH' }).toJSON()
        const defaultPart = _.find($scope.cspes, { name: 'DEFAULT_PART' }).toJSON()
        const newCspes = _.map(_.filter($scope.cspes, (cspe) => !['DEFAULT', 'DEFAULT_PRO', 'DEFAULT_PRO_HIGH', 'DEFAULT_PART'].includes(cspe.name)), (c) => c.toJSON())

        $scope.cspesPro = _.clone(newCspes)
        $scope.cspesPro.unshift(_.defaults({ name: 'DEFAULT' }, defaultPro))

        $scope.cspesProHigh = _.clone(newCspes)
        $scope.cspesProHigh.unshift(_.defaults({ name: 'DEFAULT' }, defaultProHigh))

        $scope.cspesPart = _.clone(newCspes)
        $scope.cspesPart.unshift(_.defaults({ name: 'DEFAULT' }, defaultPart))
    })

    $scope.getCspesForContract = (c) => {
        if (c.max_power <= 36) {
            return $scope.cspesPart
        }
        if (c.max_power > 250) {
            return $scope.cspesProHigh
        }
        return c.local_tax_professional_usage ? $scope.cspesPro : $scope.cspesPart
    }

    $scope.hasManagedAccountPageAccess = AuthService.getSubMenus().includes('managedAccounts')
    $scope.hasCategoriesPageAccess = AuthService.getSubMenus().includes('categories')

    $scope.isB2B = OrganizationService.isB2B

    $scope.availableFtas = _.map(ContractConstants.ref.ftas, (fta) => ({ id: fta.value, title: fta.label }))

    $scope.filterTagFilter = {
        text: undefined,
    }

    $scope.filterOpened = false
    $scope.tagFilter = {
        tagsToInclude: [],
        tagsToExclude: [],
    }

    $scope.tagFilterPayload = {
        tagsToInclude: [],
        tagsToExclude: [],
    }

    const filterSearch = {}
    $scope.contract_status_mapping = FilterMapping.contractStatus

    $scope.contractsElec = {
        show: {},
        refreshing: false,
        columns: {
            'selector': { label: 'Selection', mode: 'filter_only' },
            'id': { label: 'Id', mode: 'search_wildcard', length: 9, mandatory: true },
            'account.brand': { label: 'Compte', mode: 'search_wildcard', mandatory: true },
            'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'label': { label: 'Libellé', mode: 'search_wildcard' },
            'category.name': { label: 'Paquet facturier', mode: 'search_wildcard' },
            'status': { label: 'Statut', mode: 'search_operator', binding: 'technical_status' },
            'technical_status': { label: 'Statut', mode: 'hidden', hidden_search: 'search_operator' },
            'max_power': { label: 'Puissance', mode: 'search_operator' },
            'power_unit': { label: 'Unité puissance', mode: 'hidden' },
            'id_p_calendar': { label: 'Calendrier', mode: 'search_wildcard' },
            'routing_tariff': { label: 'FTA', mode: 'search_operator' },
            'addr_num_street': { label: 'Adresse', mode: 'search_wildcard' },
            'addr_post_code': { label: 'Code postal', mode: 'search_wildcard' },
            'addr_city_code': { label: 'Code insee', mode: 'search_wildcard' },
            'addr_city_lbl': { label: 'Ville', mode: 'search_wildcard' },
            'actual_addr_num_street': { label: 'Adresse', mode: 'hidden' },
            'actual_addr_post_code': { label: 'Code postal', mode: 'hidden' },
            'actual_addr_city_code': { label: 'Code insee', mode: 'hidden' },
            'actual_addr_city_lbl': { label: 'Ville', mode: 'hidden' },
            'metter_kind': { label: 'Type Compteur', mode: 'search_wildcard' },
            'serial_number': { label: 'Matricule', mode: 'search_wildcard' },
            'commissioning_date': { label: 'Date activation', mode: 'search_date' },
            'decommissioning_date': { label: 'Date résiliation', mode: 'search_date' },
            'id_account': { label: 'Id_account', mode: 'hidden' },
            'distributor_it': { label: 'Matricule', mode: 'hidden' },
            'segment': { label: 'Segment', mode: 'search_wildcard' },
            'category.organization': { label: 'Organisation', mode: 'hidden' },
            'category.org.type': { label: `Type d'organisation`, mode: 'hidden' },
            'account.id_grd_contract': { label: 'Id contrat GRD', mode: 'hidden' },
            'subscription_type': { label: 'Type souscription', mode: 'search_wildcard' },
            'prm_category': { label: 'Type', mode: 'search_wildcard' },
            'desired_mes_date': { label: 'Date de mise en service souhaîtée', mode: 'hidden' },
            'prm_modification_ts': { label: 'Date de modification du PRM', mode: 'hidden' },
            'service_level': { label: 'Niveau d\'ouverture aux service', mode: 'hidden', mandatory: true },
            'teleoperable': { label: 'Caractère téléopérable du point', mode: 'hidden' },
            'long_usage_context': { label: 'Contexte d\'utilisation', mode: 'hidden' },
            'long_usage_package': { label: 'Forfait (LU)', mode: 'hidden' },
            'temp_class_powers': { label: 'Puissance par classe temporelle', mode: 'hidden' },
        },
        preventQueryParamsOverride: ['activate', 'initfunction'],
    }

    if ($scope.crossOrg) {
        $scope.contractsElec.columns['category.organization'] = { label: 'Organisation', mode: 'search_wildcard' }
        $scope.contractsElec.columns['category.org.type'] = { label: 'Type d\'organisation', mode: 'search_wildcard' }
    }

    if ($stateParams.prm || $stateParams.id_contract || $stateParams.brand || $stateParams.category || $stateParams.status) {
        $scope.contractsElec.instance = {}
        $scope.contractsElec.instance.page = () => 1
        $scope.contractsElec.instance.count = () => 25
        $scope.contractsElec.instance.sorting = () => ({})
        $scope.contractsElec.instance.filter = () => _.assign(_.clone($location.search()), _.pickBy({
            'id_prm': $stateParams.prm,
            'id': $stateParams.id_contract,
            'category.name': $stateParams.category,
            'account.brand': $stateParams.brand,
            'technical_status': $stateParams.status && [$stateParams.status],
        }))
    }

    let relateds = 'account,category,governmentPriceReductionPeriods'
    // INNER BUTTONS
    $scope.canActivate = function (c) {
        $scope.activateTitle = 'Activer'
        const isActivatableStatus = (ACTIVABLE_STATUSES.indexOf(c.technical_status) > -1)
        if (!isActivatableStatus) {
            $scope.activateTitle = 'Le contrat n\'est pas dans un statut activable'
        }
        return isActivatableStatus && BoFeaturesService.isFeatureOn('canActivate')
    }

    $scope.canModifyOtPs = (contractElec) => {
        return $scope.modifOtPsB2G && contractElec.technical_status === 2 && ($scope.isC5(contractElec) || $scope.canModifyOtPsC2C4)
    }

    const refreshPrmBeforeOpeningModal = (contractElec) => {
        if (moment(contractElec.prm_modification_ts).isAfter(moment().add(-1, 'days'))) {
            return Promise.resolve()
        }
        return $scope.refreshPrm(contractElec)
    }

    // CONTRACT MANAGEMENT ACTIONS
    $scope.openModifOtPsModal = (contract) => ModalService.openModal({ type: 'modifOtPsModal', size: 'xlg', backdrop: 'static' }, {
        contract,
        consumptionAnalysis: refreshPrmBeforeOpeningModal(contract),
    })

    $scope.openActivationModal = (c) => ModalService.openModal({ type: 'contractActivationModal', size: 'xlg', backdrop: 'static' }, { contract: c, createJira: true }, () => {
        $scope.refreshContract(c)
    })

    let activationModalAlreadyAutoOpened = false
    const transform = (contractsElec) => {
        if (!activationModalAlreadyAutoOpened && $stateParams.activate && contractsElec.length === 1 && $scope.canActivate(contractsElec[0])) {
            $scope.refreshContractData(contractsElec[0]).then(() => {
                activationModalAlreadyAutoOpened = true
                $scope.openActivationModal(contractsElec[0])
            })
        }
    }

    const refresh = function () {
        if (Object.keys($scope.contractsElec.show).length > 0) {
            relateds = _.uniq(_.map(_.filter(Object.keys(_.pickBy($scope.contractsElec.show)), (s) => s.indexOf('.') > -1), (e) => {
                const lastindex = e.lastIndexOf('.')
                return e.slice(0, lastindex)
            })).join(',')
        }
        return TableGeneratorService.getTable($scope.contractsElec, 'pdls', relateds, transform, filterSearch)
    }

    $scope.refresh = refresh
    refresh()

    $scope.isActive = (state) => $state.is(state)

    $scope.refreshContractData = function (c) {
        c.refreshingData = true
        return DataAccessSearch({}).searchPaginated({
            resource: 'pdls',
            id: c.id,
            withRelated: 'account.technicalContact,prm,category,technicalContact,dataConsents,temporaryConnections',
        }).$promise.then((contractResult) => {
            _.assign(c, (contractResult.results && contractResult.results[0]) || {})
            if (c.dataConsents) {
                c.dataConsents = _.keyBy(c.dataConsents, (consent) => consent.type.toLowerCase())
            }

            c.isTemporary = !!c.temporaryConnections.length
            delete c.temporaryConnections // no need for all the temporaryConnections data
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.refreshingData = false
        })
    }

    $scope.refreshContractTags = (c) =>
        DataAccessTags.contractTags({ id_contract: c.id }).$promise.then((contractTags) => {
            c.tags = contractTags
        }).catch(ErrorCatcher)


    $scope.refreshContractReadings = function (c) {
        c.refreshingReadings = true
        return DataAccess.contractReadings({ id_contract: c.id }).$promise.then((readingsResults) => {
            const last = _.orderBy(readingsResults, 'end_date', 'desc')[0]
            if (last) {
                const filter = _.some(readingsResults, { class: 'F' }) ? { class: 'F', end_date: last.end_date } : { end_date: last.end_date }
                const lasts = _.orderBy(_.filter(readingsResults, filter), ['creation_ts', 'index_nature', 'motivation'], ['desc', 'desc', 'desc'])
                c.lastReadings = _.uniqBy(lasts, 'temp_class')
            }
            let readings = _.filter(_.orderBy(readingsResults, 'end_date'), (r) => (r.start_date !== null && r.last_value !== null))
            _.each(readings, (r) => {
                if (r.consumption == null) { // r.consumption || ... would not accept 0 consumption
                    r.cons = r.value - (r.last_value || 0)
                } else {
                    r.cons = r.consumption
                }
                r.dates = `${moment(r.start_date).format('DD/MM/YYYY')} ⮕ ${moment(r.end_date).format('DD/MM/YYYY')}`
            })
            readings = _.groupBy(readings, (r) => r.dates + r.index_nature + r.motivation)
            readings = _.map(readings, (values) => {
                // si pour ces dates il existe de la classe fournisseur on filtre dessus
                const v = _.orderBy(_.some(values, { class: 'F' }) ? _.filter(values, { class: 'F' }) : values, 'temp_class', 'desc')
                const days = moment(v[0].end_date).diff(moment(v[0].start_date), 'days')
                const cons = _.sumBy(v, 'cons')
                return {
                    index_nature: `${v[0].index_nature}${v[0].motivation.includes('REDRESS') ? ' (redressement)' : ''}`,
                    dates: v[0].dates,
                    days,
                    index: _.sumBy(v, (e) => `${e.temp_class} : ${e.last_value} ⮕ <b>${e.value}</b><br>`),
                    cons,
                    consDaily: (cons / days).toFixed(2),
                    detailsCons: (v.length > 1 ? `<br>(${_.sumBy(v, (e) => `${e.temp_class} : ${e.cons} `)})` : ''),
                }
            })
            c.readingsTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: readings,
            }) }).catch(ErrorCatcher)
        .finally(() => {
            c.refreshingReadings = false
        })
    }

    $scope.refreshContractCases = function (c) {
        c.refreshingCases = true
        return DataAccess.cases({ id_account: c.id_account, id_contract: c.id }).$promise.then((contractCases) => {
            c.cases = contractCases
        }).catch(ErrorCatcher)
        .finally(() => {
            c.refreshingCases = false
        })
    }

    $scope.refreshContractInvoices = function (c) {
        c.refreshingInvoices = true
        return DataAccessInvoices.getContractInvoices({ id_contract: c.id }).$promise.then((contractInvoices) => {
            _.each(contractInvoices, (i) => {
                i.total = _.get(i, 'preparation_result.sumup.total')
            })
            c.invoicesTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: contractInvoices,
            }) }).catch(ErrorCatcher)
        .finally(() => {
            c.refreshingInvoices = false
        })
    }

    $scope.refreshContract = function (c) {
        const refreshes = [
            $scope.refreshContractData(c),
            $scope.refreshContractReadings(c),
            $scope.refreshContractCases(c),
            $scope.refreshContractTags(c),
            $scope.refreshContractInvoices(c),
        ]
        return Promise.all(refreshes).then(() => {
            c.fetched = true
        })
    }

    $scope.expandContract = function (contractElec) {
        if (!contractElec.refreshing) {
            contractElec.expanded = !contractElec.expanded
            if (!contractElec.fetched) {
                return $scope.refreshContract(contractElec)
            }
        }
    }

    // INFORMATION TAB
    // CONTACT
    $scope.contactFields = {
        civ: {
            label: 'Civilité',
            required: true,
            type: 'radio',
            enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }],
        },
        givenname: {
            label: 'Prénom',
            required: true,
            type: 'text',
        },
        sn: {
            label: 'Nom de famille',
            required: true,
            type: 'text',
        },
        phone: {
            label: 'Téléphone',
            required: true,
            type: 'phone-all',
        },
        email: {
            label: 'E-mail',
            required: true,
            type: 'email',
        },
    }

    $scope.updateTechnicalContactPayload = (contractElec) => {
        contractElec.updatedContact = angular.copy((contractElec.technicalContact && contractElec.technicalContact.length && contractElec.technicalContact[0]) || {})
    }

    $scope.saveTechnicalContact = function (contractElec) {
        contractElec.savingContact = true
        let p
        if (contractElec.updatedContact.id) {
            p = DataAccess.updateAdditionalContact({ id: contractElec.updatedContact.id }, contractElec.updatedContact).$promise
        } else {
            contractElec.updatedContact.type = 'TECHNICAL'
            p = DataAccess.addAdditionalContact({ id_contract: contractElec.id }, contractElec.updatedContact).$promise
        }
        return p.then(() => {
            AlertManager.success('Contact mis à jour')
            return $scope.refreshContractData(contractElec) }).catch(ErrorCatcher)
        .finally(() => {
            contractElec.savingContact = false
        })
    }

    $scope.canTerminate = (c) => ([2, 5, 15].includes(c.technical_status)) && BoFeaturesService.isFeatureOn('canTerminate')

    $scope.openTerminationModal = (c) => ModalService.openModal(
        { type: 'contractTerminationModal', size: 'lg' },
        { contract: c, pro: true, energy_check_validity: false, overdueOnly: false },
        () => $scope.refreshContract(c),
    )

    $scope.openContractTransferModal = (c) => ModalService.openModal({ type: 'contractTransferModal', size: 'lg' }, { contract: c }, () => $scope.refreshContract(c))

    $scope.canSelfReport = (c) => {
        return $scope.isC5(c) && [2, 81].includes(c.technical_status) && c.fetched && c.service_level !== 2 && c.metter_kind !== 'SSCPT'
    }

    $scope.selfReportButtonTitle = (c) => {
        if ($scope.canSelfReport(c)) {
            return 'Effectuer une auto-relève sur le point'
        } else if (c.metter_kind === 'SSCPT') {
            return `Ce PDL est sans comptage, Enedis ne permet pas la saisie d'index auto-relevé`
        } else if (c.service_level === 2) {
            return `Ce PDL est équipé d'un compteur Linky communicant, Enedis ne permet pas la saisie d'index auto-relevé`
        } else if (c.status === 14) {
            return `Ce PDL est en cours de résiliation, Enedis ne permet pas la saisie d'index auto-relevé`
        } else if (!c.fetched) {
            return 'Quelques instants, le contrat est en cours de chargement'
        }
        return `Le statut du contrat ne permet pas d'effectuer une auto-relève`
    }

    $scope.openB2gSelfReportModal = (c) => ModalService.openModal({ type: 'b2gSelfReportModal', size: 'lg' }, { contract: c }, () => $scope.refreshContract(c))

    // REFRESH
    const refreshPrmData = {
        next_reading_date: 'la date de prochaine relève',
        metter_kind: 'le type de compteur',
        distributor_it: 'le SI Enedis (DISCO/GINKO)',
        distributor_status: 'l\'état contractuel chez Enedis',
        powered_status: 'l\'état d\'alimentation',
        communicating: 'le caractère communicant',
        telereport: 'présence du boitier téléreport',
        accessible: 'le caractère accessible',
        location: 'la localisation du compteur',
        circuit_breaker_range: 'le calibre du disjonteur',
        circuit_breaker_intensity: `l'intensité du disjoncteur`,
        amperage: 'l\'ampérage du compteur',
        nb_wires: 'le nombre de fils du compteur (MONO/TRIPHASÉ)',
        id_counting_practice: 'Le régime de propriété du compteur',
        metter_number: 'le matricule du compteur',
        service_level: 'le niveau d\'ouverture aux service',
        max_power: 'la puissance souscrite du point',
        id_p_calendar: 'le calendrier fournisseur',
        last_real_reading_date: 'la date de dernière relève réelle',
        long_usage_context: 'le contexte d\'utilisation',
        long_usage_package: 'le forfait (LU)',
    }

    const refreshPrmText = Object.keys(refreshPrmData).reduce((acc, k) => `${acc}<li>${refreshPrmData[k]}</li>`, '')

    $scope.refreshPrm = (c) => {
        c.refreshingPrm = true
        return ApiUser.refreshPrm({ idContract: c.id, idPrm: c.id_prm, strict: false }, { prm: 'all' }).$promise.then((updated) => {
            AlertManager.success('Mise à jour OK')
            const comment = '<b>AUTOMATIQUE</b> : PRM rafraichi'
            AdminComments.addComment({ object: c.id, comment }).$promise.catch(ErrorCatcher)
            return $scope.refreshContract(c)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.refreshingPrm = false
        })
    }


    $scope.refreshPrmTemplate = {
        expl: {
            label: `Les informations suivantes vont être mise à jour :<br><ul>${refreshPrmText}</ul>`,
            type: 'label',
        },
    }

    $scope.isC5 = (contractElec) => {
        return [undefined, 'INDET', 'C5'].includes(contractElec.segment)
    }

    // TAGS
    $scope.tagRefBackup = []
    $scope.tagPayload = { id: '' }

    DataAccessTags.getRefContractTags().$promise.then((data) => {
        $scope.tagRefBackup = _.orderBy(data, 'id')
    }).catch(ErrorCatcher)

    $scope.filterContractTags = function (c) {
        const tagRef = []
        $scope.tagRefBackup.forEach((datum) => {
            if (!_.find(c.tags, { id_tag: datum.id })) {
                return tagRef.push({ value: datum.id, label: datum.text })
            }
        })
        c.tagFields = {
            id: {
                required: true,
                label: 'Nom',
                placeholder: 'Nom',
                type: 'select',
                enum: tagRef,
            },
        }
    }

    const resetTagPayload = function () {
        const tagTemplate = { id: '' }
        $scope.tagPayload = angular.copy(tagTemplate)
    }

    $scope.addTag = (c) =>
        DataAccessTags.addContractTag({ id_contract: c.id, id_tag: $scope.tagPayload.id }).$promise.then(() => {
            AlertManager.success('Tag ajouté')
            resetTagPayload()
            return $scope.refreshContractTags(c) }).catch(ErrorCatcher)


    $scope.deleteTag = (c, tag) =>
        DataAccessTags.delContractTag({ id: tag.id }).$promise.then(() => {
            AlertManager.success('Tag retiré')
            return $scope.refreshContractTags(c) }).catch(ErrorCatcher)


    // TAG FILTER
    $scope.updateResultWithTagFilter = function () {
        if ($scope.tagFilter.tagsToInclude.length) {
            filterSearch.exists = [`tags.id_tag=${_.map($scope.tagFilter.tagsToInclude, 'id').join(',')}`]
        } else {
            delete filterSearch.exists
        }
        if ($scope.tagFilter.tagsToExclude.length) {
            filterSearch.notexists = [`tags.id_tag=${_.map($scope.tagFilter.tagsToExclude, 'id').join(',')}`]
        } else {
            delete filterSearch.notexists
        }
        return refresh()
    }

    $scope.addTagToIncludeFilter = () => $scope.tagFilter.tagsToInclude.push(_.find($scope.tagRefBackup, { id: $scope.tagPayload.id }))

    $scope.addTagToIncludeFilter = () => $scope.tagFilter.tagsToInclude.push(_.find($scope.tagRefBackup, { id: $scope.tagPayload.id }))

    $scope.deleteTagFromIncludeFilter = function (tag) {
        _.remove($scope.tagFilter.tagsToInclude, { id: tag.id })
        $scope.updateTagFilterPayload()
        return $scope.updateResultWithTagFilter()
    }

    $scope.deleteTagFromExcludeFilter = function (tag) {
        _.remove($scope.tagFilter.tagsToExclude, { id: tag.id })
        $scope.updateTagFilterPayload()
        return $scope.updateResultWithTagFilter()
    }

    $scope.toggleFilterTag = function (tag) {
        if (!_.find($scope.tagFilterPayload.tagsToInclude, { id: tag.id }) && !_.find($scope.tagFilterPayload.tagsToExclude, { id: tag.id })) {
            return $scope.tagFilterPayload.tagsToInclude.push(tag)
        } else if (_.find($scope.tagFilterPayload.tagsToInclude, { id: tag.id })) {
            _.remove($scope.tagFilterPayload.tagsToInclude, { id: tag.id })
            return $scope.tagFilterPayload.tagsToExclude.push(tag)
        }
        return _.remove($scope.tagFilterPayload.tagsToExclude, { id: tag.id })
    }

    $scope.isTagIncluded = (tag) => !!_.find($scope.tagFilterPayload.tagsToInclude, { id: tag.id })

    $scope.isTagExcluded = (tag) => !!_.find($scope.tagFilterPayload.tagsToExclude, { id: tag.id })

    $scope.isNotFiltered = (tag) => !($scope.isTagIncluded(tag) || $scope.isTagExcluded(tag))

    $scope.updateTagFilterPayload = () => {
        $scope.tagFilterPayload = angular.copy($scope.tagFilter)
    }

    $scope.updateTagFilter = function () {
        $scope.filterOpened = false
        $scope.tagFilter = angular.copy($scope.tagFilterPayload)
        return $scope.updateResultWithTagFilter()
    }

    // INLINE EDITION
    $scope.prevent = function (e) {
        e.preventDefault()
        return e.stopPropagation()
    }

    $scope.copied = function (e, objectName) {
        $scope.prevent(e)
        return AlertManager.success(`${objectName} copié !`)
    }

    // LABEL EDITION
    $scope.editLabelFields = {
        newLabel: {
            label: 'Libellé',
            type: 'text',
        },
    }

    $scope.toggleOnLabelEditing = function (c) {
        c.newLabel = c.label
        c.editLabel = true
    }

    $scope.toggleOffLabelEditing = (c) => {
        c.editLabel = false
    }

    $scope.updateLabel = (c) =>
        DataAccess.updateContractInfos({ id_contract: c.id }, { label: c.newLabel }).$promise.then(() => {
            AlertManager.success('Label mis à jour')
            c.editLabel = false
            c.label = c.newLabel
        }).catch(ErrorCatcher)


    // CONTRACT DATE EDITION
    $scope.toggleOnCommEditing = function (c) {
        c.newCommissioningDate = c.commissioning_date
        c.editCommissioningDate = true
    }

    $scope.toggleOnDecommEditing = function (c) {
        c.newDecommissioningDate = c.decommissioning_date
        c.editDecommissioningDate = true
    }

    $scope.editCommFields = {
        newCommissioningDate: {
            label: `Date d'activation`,
            type: 'date',
            required: true,
        },
    }

    $scope.editDecommFields = {
        newDecommissioningDate: {
            label: `Date de résiliation`,
            type: 'date',
            required: true,
        },
    }

    const updateContractDate = (contractElec, payload) => {
        contractElec.changingDates = true
        return DataAccess.modifyContractDate({ id_contract: contractElec.id }, payload).$promise.then((result) => {
            AlertManager.success('Date mise à jour')
            $scope.refreshContract(contractElec)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            contractElec.changingDates = false
        })
    }

    $scope.updateCommDate = (contractElec) => {
        return updateContractDate(contractElec, { commissioning_date: contractElec.newCommissioningDate })
    }

    $scope.updateDecommDate = (contractElec) => {
        return updateContractDate(contractElec, { decommissioning_date: contractElec.newDecommissioningDate })
    }



    // MASS ACTIONS
    $scope.recapActivation = {}
    $scope.activationPayload = {
        concurrency: 10,
        force_inter: false,
    }
    $scope.recapTermination = {}
    $scope.terminationPayload = {
        concurrency: 5,
        force_inter: false,
    }

    $scope.toggleSelected = function (contractElec, e) {
        e.preventDefault()
        e.stopPropagation()
        contractElec.selected = !contractElec.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.contractsElec.instance.data, (c) => {
            c.selected = true
        })


    $scope.deSelectAll = () =>
        _.forEach($scope.contractsElec.instance.data, (c) => {
            c.selected = false
            return true
        })


    $scope.getActivables = () =>
        _.filter($scope.contractsElec.instance.data, (c) => c.selected && Array.from(ACTIVABLE_STATUSES).includes(c.technical_status))


    $scope.getTerminables = () =>
        _.filter($scope.contractsElec.instance.data, (c) => c.selected && [2].includes(c.technical_status))


    $scope.getSelectedNumber = () => _.countBy($scope.contractsElec.instance.data, 'selected').true || 0

    $scope.generateRecapActivation = function () {
        const activables = $scope.getActivables()
        let list = ''
        _.forEach(activables, (a) => {
            list += `<li>${a.id} - ${a.id_prm}</li>`
        })
        $scope.recapActivation = {
            expl: {
                label: `Êtes-vous sûr de vouloir activer : <b>${activables.length}</b> contrats ?<br><ul>${list}</ul>`,
                type: 'label',
            },
            concurrency: {
                label: `Appels en parallèle`,
                type: 'number',
            },
        }
        const needInter = _.filter(activables, (a) => ['MES_INTER', 'FIRST_MES', 'CDF_INTER'].includes(a.subscription_type))
        if (needInter.length) {
            const listInter = `<li>${_.map(needInter, 'id').join('</li><li>')}</li>`
            $scope.recapActivation.inter = {
                label: `Ces points nécessitent une intervention :<br><ul>${listInter}</ul>`,
                type: 'label',
            }
            $scope.recapActivation.force_inter = {
                label: 'Lancer une intervention automatique au 1er créneau disponible ?',
                type: 'checkbox',
                required: true,
            }
        }
        $scope.recapActivation.silent = {
            label: 'Ne pas envoyer de mail de notification',
            type: 'checkbox',
        }
    }

    $scope.generateRecapTermination = function () {
        const terminables = $scope.getTerminables()
        let list = ''
        _.forEach(terminables, (a) => {
            list += `<li>${a.id} - ${a.id_prm}</li>`
        })
        $scope.recapTermination = {
            expl: {
                label: `Êtes-vous sûr de vouloir résilier : <b>${terminables.length}</b> contrats ?<br><ul>${list}</ul>`,
                type: 'label',
            },
        }

        const needInter = _.filter(terminables, (t) => !PrmUtilsService.isLinkyN2(_.pick(t, ['service_level', 'teleoperable'])))
        if (needInter.length) {
            const listInter = `<li>${_.map(needInter, 'id').join('</li><li>')}</li>`
            $scope.recapTermination.inter = {
                label: `${needInter.length} points nécessitent une intervention :<br><ul>${listInter}</ul>`,
                type: 'label',
            }
            $scope.recapTermination.force_inter = {
                label: 'Lancer une intervention automatique au 1er créneau disponible ?',
                type: 'checkbox',
                required: true,
            }
            if (needInter.some((contract) => ['C2', 'C3', 'C4', 'INDET_C2_C3'].includes(contract.segment))) {
                $scope.recapTermination.is_known_successor = {
                    label: 'Le successeur du point est connu ? (pour les contrats séléctionnés sur segment C2, C3 ou C4)',
                    type: 'radio',
                    enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
                    required: true,
                }
                $scope.recapTermination.is_customer_informed = {
                    label: 'Le client a été informé ? (pour les contrats séléctionnés sur segment C2, C3 ou C4)',
                    type: 'radio',
                    enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
                    required: true,
                }
            }
        }
        $scope.recapTermination.concurrency = {
            label: `Appels en parallèle`,
            type: 'number',
        }
    }

    $scope.massActivate = () => {
        $scope.massActivating = true
        const contractList = _.map($scope.getActivables(), (c) => _.pick(c, 'id'))
        return ApiUser.massActivate({
            force_inter: $scope.activationPayload.force_inter,
            silent: $scope.activationPayload.silent,
        }, { concurrency: $scope.activationPayload.concurrency, contractList }).$promise.then((result) => {
            AlertManager.success('Activation(s) demandée(s)')
            refresh()
            return ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result: { Succès: result.success, Erreurs: result.error } }) })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massActivating = false
        })
    }

    $scope.massTerminate = () => {
        const contractToTerminate = $scope.terminationPayload.force_inter ?
            $scope.getTerminables() :
            _.filter($scope.getTerminables(), (t) => PrmUtilsService.isLinkyN2(_.pick(t, ['service_level', 'teleoperable'])))
        if (!contractToTerminate.length) {
            return AlertManager.success(`Aucun point à résilier, cocher l'intervention automatique pour résilier ces contrats`)
        }
        $scope.massTerminating = true
        const contractList = _.map(contractToTerminate, (c) => _.pick(c, 'id'))
        return ApiUser.massTerminate($scope.terminationPayload, { contractList }).$promise.then((result) => {
            AlertManager.success('Résiliation(s) demandée(s)')
            ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massTerminating = false
            refresh()
        })
    }

    const contractTransitions = BoFeaturesService.getModuleFeatures('contractTransitions')
    const allowedTransitions = {}

    _.each(contractTransitions, (v, k) => {
        if (v) {
            const [from, to] = k.split('>')
            allowedTransitions[from] = allowedTransitions[from] || []
            allowedTransitions[from].push(to)
        }
    })

    $scope.changeStatus = {
        payloads: {
            status: null,
        },
        fields: {
            status: {
                label: 'Status',
                type: 'select',
                required: true,
                placeholder: 'Changement de status',
                enum: [],
            },
        },
        isEnabled(contractElec) {
            return _.keys(allowedTransitions).includes(`${contractElec.technical_status}`)
        },
        preparePopup(contractElec) {
            if (allowedTransitions[contractElec.technical_status]) {
                $scope.changeStatus.payloads = { status: allowedTransitions[contractElec.technical_status][0] }
                $scope.changeStatus.fields.status.enum = _.map(allowedTransitions[contractElec.technical_status], (s) => {
                    return {
                        value: s,
                        label: `${$filter('contractStatus')(contractElec.technical_status)} ➔ ${$filter('contractStatus')(s)}`,
                    }
                })
            } else {
                $scope.changeStatus.payloads = { status: null }
                $scope.changeStatus.fields.status.enum = []
            }
        },
        update(contractElec) {
            const comment = `
                <b>AUTOMATIQUE</b> : changement de statut manuel par un admin :
                <b>${contractElec.status}</b> ➔ <b>${$filter('contractStatus')($scope.changeStatus.payloads.status)}</b>`
            return DataAccess.changeContractStatus({
                id_contract: contractElec.id,
                status: $scope.changeStatus.payloads.status,
            }, {}).$promise.then(() => {
                AlertManager.success('Status changé')
                AdminComments.addComment({ object: contractElec.id, comment }).$promise.catch(ErrorCatcher)
                $scope.refreshContract(contractElec)
            }).catch(ErrorCatcher)
        },
    }

    // CATEGORY EDITION
    let refCategories

    const refreshCategoryWarnings = [
        `La liste des changements permis est restreine au même compte et même SIRET, sinon passer par une MES/RES (prestation payante).`,
        `Le changement peut impliquer des complications lors de l'annulation de facture dans le paquet facturier d'origine. En cas d'annulation de facture du paquet
         d'origine antérieures à la date de changement de paquet facturier, les factures du paquet receveur devront également être annulées puis rééditées.`,
        `Le changement implique que les potentielles régularisations de consommation émise par Enedis sur une période antérieure à la date de changement de paquet
        facturier seront facturées sur le nouveau paquet facturier.`,
    ]

    $scope.editCategoryFields = {
        newCategory: {
            label: `Attention avant de changer le paquet facturier :<br><ul>${refreshCategoryWarnings.reduce((acc, warning) => `${acc}<li>${warning}</li>`, '')}</ul><br>Paquet Facturier`,
            type: 'typeahead',
            limitTo: 20,
            enum: [],
        },
    }

    $scope.refreshCategories = (contract) =>
        DataAccess.getRefContractCategories({ id_account: contract.id_account, energy_type: 'ELEC', siret: contract.category.siret }).$promise.then((categories) => {
            refCategories = categories
            $scope.editCategoryFields.newCategory.enum = _.map(refCategories, (category) => ({ label: category.name, value: category.id }))
        }).catch(ErrorCatcher)


    $scope.toggleOnCategoryEditing = function (c) {
        c.newCategory = c.id_category
        $scope.refreshCategories(c).then(() => {
            c.editCategory = true
        })
    }

    $scope.toggleOffCategoryEditing = (c) => {
        c.editCategory = false
    }

    $scope.openTemporaryConnectionModal = () => {
        ModalService.openModal({ type: 'temporaryConnectionModal', size: 'lg' }, { id_account: null })
    }

    $scope.updateCategory = (c) =>
        DataAccess.updateContractInfos({ id_contract: c.id }, { id_category: c.newCategory }).$promise.then(() => {
            AlertManager.success('Paquet facturier mis à jour')
            c.editCategory = false
            c.id_category = c.newCategory
            c.category = _.find(refCategories, { id: c.id_category }) })
        .catch(ErrorCatcher)


    $scope.offerConfigurationFields = {
        prm_category: {
            label: 'Type de point',
            type: 'select',
            required: true,
            enum: [
                { value: 'EP', label: 'EP ou assimilés' },
                { value: 'Batiment', label: 'Bâtiment' },
            ],
        },
        provider_offer: {
            label: 'Offre fournisseur',
            type: 'select',
            required: true,
            enum: [],
        },
        cons_profile: {
            label: 'Profil de consommation',
            type: 'select',
            required: true,
            enum: [
                { value: 'PRO1', label: 'PRO1' },
                { value: 'PRO2', label: 'PRO2' },
                { value: 'PRO3', label: 'PRO3' },
                { value: 'PRO5', label: 'PRO5' },
                { value: 'PRO6', label: 'PRO6' },
                { value: 'ENT1', label: 'ENT1' },
                { value: 'ENT3', label: 'ENT3' },
            ],
        },
        retroActive: {
            label: `Modifier également tout l'historique depuis la mise en service du point ?`,
            type: 'checkbox',
        },
        warning: {
            type: 'label',
            hidden: (template) => !template.retroActive,
            label: `<span class="red"><span class="fa fa-warning"></span> ` +
                `Attention, si le point a déjà été inclus dans une facture il conviendra d'annuler et refaire les factures concernées !</span>`,
        },
    }

    $scope.offerConfigurationTemplate = {}

    $scope.updateOfferConfigurationTemplate = (c) => {
        _.assign($scope.offerConfigurationTemplate, _.pick(c, ['prm_category', 'provider_offer', 'cons_profile']))
        $scope.offerConfigurationTemplate.retroActive = true
        c.fetchingOffers = true
        return DataAccess.getContractAvailableProviderOffers({ id_contract: c.id }).$promise.then((offers) => {
            $scope.offerConfigurationFields.provider_offer.enum = _.map(offers, (offer) => ({ value: offer.id, label: offer.label }))
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.fetchingOffers = false
        })
    }


    $scope.billingConfigurationFields = {
        cee_exemption: {
            label: 'Exemption de CEE',
            type: 'checkbox',
            required: true,
        },
        tcfe_coef: {
            label: 'Coeficient TCFE (de 0 à 1)',
            type: 'number',
            min: 0,
            max: 1,
            step: '0.01',
            required: true,
        },
        ref_tax_cspe: {
            label: 'Tarif CSPE',
            type: 'radio',
            enum: [],
            required: true,
        },
        local_tax_professional_usage: {
            label: `Type d'usage`,
            type: 'select',
            enum: [{ value: true, label: `Professionnel` }, { value: false, label: `Non-professionnel` }],
            required: true,
        },
        retroActive: {
            label: `Modifier également tout l'historique depuis la mise en service du point ?`,
            type: 'checkbox',
        },
        warning: {
            type: 'label',
            hidden: (template) => !template.retroActive,
            label: `<span class="red"><span class="fa fa-warning"></span> ` +
                `Attention, si le point a déjà été inclus dans une facture il conviendra d'annuler et refaire les factures concernées !</span>`,
        },
    }

    $scope.billingConfigurationTemplate = {}

    $scope.updateBillingConfigurationTemplate = (c) => {
        const cspeList = $scope.getCspesForContract(c)
        $scope.billingConfigurationFields.ref_tax_cspe.enum = _.map(cspeList, (cspe) => ({ value: cspe.name, label: `${cspe.label} (${cspe.unit_price} €/MWh)` }))
        $scope.billingConfigurationTemplate.retroActive = true
        _.assign($scope.billingConfigurationTemplate, _.pick(c, ['cee_exemption', 'tcfe_coef', 'ref_tax_cspe', 'local_tax_professional_usage']))
    }

    $scope.updateBillingConfiguration = (c, update) =>
        DataAccess.updateContractElecBillingInfos({ id_contract: c.id, retroActive: update.retroActive }, _.omit(update, ['retroActive'])).$promise.then(() => {
            AlertManager.success('Configuration mise à jour')
            $scope.refreshContractData(c)
        })
        .catch(ErrorCatcher)



    $scope.governmentPriceReductionsFields = {
        type: {
            label: `Type de dispositif`,
            type: 'select',
            enum: [{ value: 'collective-tariff-shield', label: `Bouclier tarifaire collectif` }],
            required: true,
            onSelect: (value) => {
                switch (value) {
                  case 'collective-tariff-shield':
                    $scope.governmentPriceReductionsTemplate.valid_from = '2022-07-01',
                    $scope.governmentPriceReductionsTemplate.valid_to = '2023-12-31'
                    break;
                }
            }
        },
        valid_from: {
            label: 'Début',
            type: 'date',
            required: true,
        },
        valid_to: {
            label: 'Fin',
            type: 'date',
            required: true,
        },
        unit_price: {
            label: 'Montant par kWh',
            type: 'number',
            min: 0,
            required: true,
        },
    }

    $scope.governmentPriceReductionsTemplate = {}

    $scope.updateGovernmentPriceReductionsTemplate = (gpr) => {
        if (!gpr) {
            $scope.governmentPriceReductionsTemplate.type = null
            $scope.governmentPriceReductionsTemplate.unit_price = null
            $scope.governmentPriceReductionsTemplate.valid_from = null
            $scope.governmentPriceReductionsTemplate.valid_to = null
        } else {
            $scope.governmentPriceReductionsTemplate.type = gpr.type
            $scope.governmentPriceReductionsTemplate.unit_price = gpr.unit_price
            $scope.governmentPriceReductionsTemplate.valid_from = gpr.valid_from
            $scope.governmentPriceReductionsTemplate.valid_to = gpr.valid_to
        }
    }

    $scope.updateGovernmentPriceReductions = (contract, gpr, update) => {
        GovernmentPriceReductionPeriod.updateContractGovernmentPriceReductionPeriod({
            idPeriod: gpr.id,
        }, {
            unit_price: update.unit_price,
            valid_from: update.valid_from,
            valid_to: update.valid_to,
            type: update.type,
            unit_price: update.unit_price,
        }).$promise.then((result) => {
            gpr.unit_price = update.unit_price
            gpr.valid_from = update.valid_from
            gpr.valid_to = update.valid_to
            gpr.type = update.type
            AlertManager.success('Dispositif mis à jour')
        }).catch(ErrorCatcher)
    }
    $scope.addGovernmentPriceReductions = (contract, update) => {
        GovernmentPriceReductionPeriod.addContractGovernmentPriceReductionPeriod({
        }, {
            id_contract: contract.id,
            unit_price: update.unit_price,
            valid_from: update.valid_from,// was '2023-01-01'
            valid_to: update.valid_to,// was'2023-12-31',
            type: update.type,
        }).$promise.then((result) => {
            contract.governmentPriceReductionPeriods.push(result)
            AlertManager.success('Dispositif ajouté')
        }).catch(ErrorCatcher)
    }

    $scope.deleteGovernmentPriceReductions = (contract, gpr) => {
        GovernmentPriceReductionPeriod.deleteContractGovernmentPriceReductionPeriod({
            idPeriod: gpr.id,
        }).$promise.then((result) => {
            let idx = contract.governmentPriceReductionPeriods.findIndex((period) => period.id === gpr.id)
            contract.governmentPriceReductionPeriods.splice(idx, 1)
            AlertManager.success('Dispositif supprimé')
        }).catch(ErrorCatcher)
    }


    // DL LINK
    $scope.dlInvoice = (invoice, id_account) => {
        return DownloadService.downloadInvoice(invoice.download_link, id_account)
    }

    $scope.isContractActive = (contract) => {
        return [2, 14, 4].includes(contract.technical_status)
    }

    if ($stateParams.initfunction) {
        $scope[$stateParams.initfunction]()
    }

    $scope.openEnedisServicesModal = (c) => {
        ModalService.openModal({ type: 'enedisServicesModal', size: 'lg' }, {
            idContract: c.id,
        })
    }
})
